import Duration from './Duration';
import DurationUnit from './DurationUnit';

export default class Timepoint {

	public constructor (private microtimestamp: number) {}

	public static now () {
		return new Timepoint(new Date().getTime() * 1000);
	}

	public getMicrotimestamp () {
		return this.microtimestamp;
	}

	public equals (other: Timepoint) {
		return this.microtimestamp === other.microtimestamp;
	}

	public isAfter (other: Timepoint) {
		return this.microtimestamp > other.getMicrotimestamp();
	}

	public isBefore (other: Timepoint) {
		return this.microtimestamp < other.getMicrotimestamp();
	}

	public plus (duration: Duration) {
		if (duration.getUnit().is(DurationUnit.MONTH)) {
			throw Error('Timepoint.plus not implemented for months');
		}

		return new Timepoint(this.microtimestamp + duration.getMicroseconds());
	}
}


// WEBPACK FOOTER //
// ./code/foundation/time/Timepoint.ts